export const PalletReservationState = {
	ALL: 0,
	RESERVED: 1,
	AVAILABLE: 2,
	OTHER_ORDERS: 3,
};

export const PalletReservationStateName = {
	[PalletReservationState.ALL]: "all",
	[PalletReservationState.RESERVED]: "reserved",
	[PalletReservationState.AVAILABLE]: "available",
	[PalletReservationState.OTHER_ORDERS]: "other_orders",
};
